(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', function(event) {
    const swatch = event.target.closest('.custom-color-swatch');
    if (!swatch) return;

    const card = swatch.closest('product-card');
    if (!card) return;

    const image = card.querySelector('.custom-product-card-image');
    const title = card.querySelector('.custom-product-card-title');
    const price = card.querySelector('.custom-product-card-price');
    const links = card.querySelectorAll('a[href]');

    if (swatch.dataset.image && image) {
      image.src = swatch.dataset.image;
      image.srcset = '';
    }

    if (swatch.dataset.title && title) {
      title.textContent = swatch.dataset.title;
    }

    if (swatch.dataset.price && price) {
      price.textContent = swatch.dataset.price;
    }

    if (swatch.dataset.url) {
      links.forEach(function(link) {
        link.href = swatch.dataset.url;
      });
    }

    card.querySelectorAll('.custom-color-swatch').forEach(function(button) {
      button.classList.remove('is-active');
    });

    swatch.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
